import { ListFeaturesResponse } from '@cast/types-cluster-management';

export const generateClusterManagementFeatures = (): ListFeaturesResponse => {
  return {
    items: [
      {
        id: 'f892b414-a8be-4623-b35b-05ebf345e090',
        name: 'ai-optimizer',
        displayName: 'AI Enabler',
      },
      {
        id: '49909b64-67ee-4929-aa03-63308458c85f',
        name: 'autoscaler',
        displayName: 'Autoscaler',
      },
      {
        id: '0d18a5f7-5140-43ac-8240-0223317edf60',
        name: 'db-optimizer',
        displayName: 'Database optimizer',
      },
      {
        id: '5b64317e-4402-45fc-873c-6c04f60639f9',
        name: 'generic',
        displayName: 'Generic',
      },
      {
        id: '13de15b7-5a8c-438b-9703-05c2b348fb97',
        name: 'reporting',
        displayName: 'Reporting',
      },
      {
        id: '56dd617c-7032-4a1f-90c1-869efe03c32c',
        name: 'security',
        displayName: 'Security',
      },
      {
        id: '24ca2e41-05de-4cb1-ac5a-429d847c6cf3',
        name: 'woop',
        displayName: 'Workload optimization',
      },
    ],
  };
};
